import { render, staticRenderFns } from "./finished-inputs.vue?vue&type=template&id=20dbe0e9&"
import script from "./finished-inputs.vue?vue&type=script&lang=js&"
export * from "./finished-inputs.vue?vue&type=script&lang=js&"
import style0 from "./finished-inputs.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports